import { handleActions } from 'redux-actions'
import { setLoadingJoinGoal, setLoadingJoinGoalDone } from './loadingActions'

class State {
  joinGoal = false
}

export const loading = handleActions<State, any>(
  {
    [String(setLoadingJoinGoal)]: (state: State): State => ({
      ...state,
      joinGoal: true,
    }),
    [String(setLoadingJoinGoalDone)]: (state: State): State => ({
      ...state,
      joinGoal: false,
    }),
  },
  new State(),
)

export { State as LoadingState }
